import { config } from '../config';
export const appCategories = [ ['all','Toutes les catégories'], ['utilitaire','Utilitaires'], ['education','Éducation'], ['productivite','Productivité'], ['divertissement','Divertissement'], ['communication','Communication'] ];
export const applicationFormats = ['apk','exe','msi','msix','msixbundle','appx','appxbundle','zip'];
export function applicationPlatform(app) {
  const ext = String(app.fichier || '').split('.').pop().toLowerCase();
  return ext === 'apk' ? 'android' : ext === 'zip' ? 'archive' : ['exe','msi','msix','msixbundle','appx','appxbundle'].includes(ext) ? 'windows' : 'other';
}
export function formatApplicationSize(value) {
  const bytes = Number(value); if (!Number.isFinite(bytes) || bytes <= 0) return 'Taille non renseignée';
  const units = ['o','Ko','Mo','Go'], i = Math.min(3, Math.floor(Math.log(bytes) / Math.log(1024)));
  return new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 1}).format(bytes / Math.pow(1024, i)) + ' ' + units[i];
}
export function applicationShareUrl(app) {
  const id = Number(app.id_app); if (!Number.isSafeInteger(id) || id <= 0) throw new Error('Application invalide.');
  return config.apiBase + '/applications/share.php?id=' + id;
}
export async function shareApplication(app) {
  const url = applicationShareUrl(app);
  const title = app.nom || 'Application IPTIC';
  const text = title + (app.version ? ' · Version ' + app.version : '') + '\n' +
    String(app.description || '').slice(0, 400) + '\nIPTIC-Golkoye · Sciences & Numérique';
  if (navigator.share) {
    try { await navigator.share({title, text, url}); return 'shared'; }
    catch (error) { if (error.name === 'AbortError') return 'cancelled'; }
  }
  if (navigator.clipboard && window.isSecureContext) { await navigator.clipboard.writeText(url); return 'copied'; }
  window.prompt('Lien de l’application', url); return 'copied';
}
